
export class Cloneable {

    clone(target) {
        if (target) {
            for (let key in this) {
                if (key.charAt(0) === '_') {
                    target[key] = Cloneable.cloneValue(this[key]);
                }
            }
        }
        return target;
    }

    static cloneValue(value) {
        if (value instanceof Cloneable) {
            return value.clone();
        } else if (Array.isArray(value)) {
            return value.map(v => Cloneable.cloneValue(v));
        } else if (value instanceof Object) {
            //return Object.create(value);
            return JSON.parse(JSON.stringify(value));
        } else {
            return value;
        }
    }
}

if (!Array.prototype.clone) {
    Object.defineProperty(Array.prototype, 'clone', {
        value: function () {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw TypeError('"this" is null or not defined');
            }

            return this.map(v => Cloneable.cloneValue(v));
        },
        configurable: true,
        writable: true
    });
}